import { IFile } from '@shared/interfaces/file';
import { AppUser } from '@core/services/user.service';
import { parseISO } from '@core/date.facade';
import { User } from '@core/services/api/u2b-user.api-service';

export type AvvStatus = 'pending' | 'confirmed' | 'outdated';

export interface IAvv {
    id: number;
    user: AppUser;
    signedBy: User;
    signedOn: string | Date;
    file: IFile;
    user_id: string;
    tenant_files_id: number;
    status: AvvStatus;
}

export class Avv implements IAvv {
    id: number;
    user: AppUser;
    signedBy: User;
    signedOn: Date;
    file: IFile;
    // tslint:disable-next-line:variable-name
    user_id: string;
    // tslint:disable-next-line:variable-name
    tenant_files_id: number;
    status: AvvStatus;

    constructor(avv = {} as IAvv) {
        this.id = avv?.id;
        this.user = avv?.user;
        this.signedBy = avv?.signedBy;
        this.signedOn = avv?.signedOn ? parseISO(avv.signedOn as string) : null;
        this.file = avv?.file;
        this.user_id = avv?.user_id;
        this.tenant_files_id = avv?.tenant_files_id;
        this.status = avv?.status ?? null;
    }

    get isConfirmed(): boolean {
        return this.status === 'confirmed';
    }

    get isPending(): boolean {
        return this.status === 'pending';
    }

    get isOutdated(): boolean {
        return this.status === 'outdated';
    }

    get isPendingExpired(): boolean {
        if (!this.isPending || !this.signedOn) {
            return false;
        }
        const fourWeeksMs = 28 * 24 * 60 * 60 * 1000;
        return (Date.now() - this.signedOn.getTime()) > fourWeeksMs;
    }
}
